<template>
  <div id="sellerFollowingPage">
    <v-main class="overflow-hidden">
      <BackBar/>

      <div class="container-fluid px-1">
        <div class="row">
          <div class="col-12 col-md-6 mx-auto pt-0">
            <div class="row ">
              <div class="col-12">
                <div class="bg-white py-5 px-3 rounded-lg">
                  <i class="fa-solid fa-user-plus fa-2xl transform-icon-to-top"></i>
                  <span class="font16px mr-2 font-weight-bold">دنبال شده ها</span>
                </div>
              </div>
            </div>
            <div class="row">
              <div v-if="following.length <= 0" class="col-12  text-center">
                <div><i class="fa-light fa-face-frown-slight fa-3x grey--text"></i></div>
                <div class="mt-2">
                  دنبال شده ای وجود ندارد
                </div>

              </div>
              <div v-else class="col-12">
                <div class="row">
                  <div class="col pt-0 ">
                    <v-text-field
                        v-model="searchKeyWord"
                        @keyup="search"
                        append-icon="far fa-magnifying-glass"
                        class="rounded-lg"
                        dense
                        flat
                        clearable
                        @click:clear="removeSearchHistory"
                        hide-details
                        placeholder="...Search Name"
                        solo>
                    </v-text-field>
                  </div>
                  <div class="col-12 px-10">
                    <span>تعداد دنبال شده ها</span>
                    <span class="float-left">{{ followingCount }}</span>
                  </div>
                </div>
                <div v-if="!hasFavoriteResult" class="col-12 text-center">
                  نتیجه ای یافت نشد
                </div>
                <div v-else class="row mx-1">


                  <div v-for="(item,i) in following"  :key="i" class="col-4 p-1 ">
                    <router-link :to="{path:'ProfileInSite',query:{ID:item.FollowedAppUserId}}"  v-if="item.FollowedAppUserId !== null" class="p-2 text-center bg-white rounded-lg d-block">
                      <v-avatar size="70">
                        <img v-if="item.UserImageUrl !== null"
                             :src="$replaceHttps(item.UserImageUrl)" alt="تصویر کاربر">
                        <i v-else class="fas fa-user-plus fa-3x"></i>
                      </v-avatar>
                      <div class="text-truncate mt-2 font-weight-bold">{{ item.VendorName }}</div>
                      <div class="text-truncate font12px m-0 bio-text" v-html=" item.UserBio"></div>

                      <div class="mt-2">
                        <v-btn  color="primary"
                                block
                                class="rounded-lg" depressed
                                small @click.prevent.stop="removeFollowedClient(item.FollowedAppUserId)">
                          <span >دنبال شد</span>
                        </v-btn>
                      </div>
                      <div class="text-center mt-2">
                        {{ $convertDate(item.ModifiedDate) }}
                      </div>

                    </router-link>
                    <router-link :to="{path:'StoreProfile',query:{VendorID:item.VendorID}}" v-else class="p-2 text-center bg-white rounded-lg d-block">
                      <v-avatar size="70">
                        <img v-if="item.VendorImageUrl !== null"
                             :src="$replaceHttps(item.VendorImageUrl)" alt="لوگو فروشگاه">
                        <i v-else class="fas fa-store fa-3x"></i>
                      </v-avatar>
                      <div class="text-truncate mt-2 font-weight-bold">{{ item.VendorName }}</div>
                      <div class="text-truncate font12px m-0 bio-text" v-html=" item.VendorBio"></div>
                      <div class="mt-2">
                        <v-btn  color="primary"
                                block
                                class="rounded-lg" depressed
                                small @click.prevent.stop="removeFollowedVendor(item.VendorID)">
                          <span >دنبال شد</span>
                        </v-btn>
                      </div>
                      <div class="text-center mt-2">
                        {{ $convertDate(item.ModifiedDate) }}
                      </div>

                    </router-link>
                  </div>
                </div>
              </div>
            </div>



          </div>
        </div>
      </div>
    </v-main>
    <v-overlay :value="showLoaderDialog">
      <div class="loading-spinner">
      </div>
    </v-overlay>
    <v-snackbar
        v-model="showResult"
        :multi-line="true"
        color="primary">
      {{ resultText }}

      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" icon @click="showResult = false ">
          <i class="fa-solid fa-circle-xmark fa-xl white--text"></i>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import BackBar from "@/components/BackBar";

export default {
  name: "SellerFollowing",
  metaInfo: {
    title: 'ایوان خانه- دنبال شده ها',
  },
  components: {BackBar},
  data: () => ({
    followingCount: 0,
    following: [],
    allFollowing: [],
    isDataLoaded: false,
    showLoaderDialog: false,
    showResult: false,
    resultText: null,
    searchKeyWord:'',
    hasFavoriteResult:true,
  }),
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.showLoaderDialog = true
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "VendorPanel/BookMarkVendor/_FollowingList", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.followingCount= json.length
            this.following = json
            this.allFollowing = json
            this.showLoaderDialog = false
            this.isDataLoaded = true
          })
          .catch(error => console.log('error', error));

    },
    search(){

      let result = this.following.filter(x => x.VendorName.includes(this.searchKeyWord));
      if (this.searchKeyWord === '') {
        this.following =this.allFollowing
      } else {
        if (result.length === 0) {
          this.hasFavoriteResult = false
        } else {
          this.hasFavoriteResult = true
          this.following = result
        }
      }
    },
    removeSearchHistory() {
      this.following =this.allFollowing
      this.hasFavoriteResult = true
    },
    removeFollowedClient(id){
      this.showLoaderDialog = true

      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let urlencoded = new URLSearchParams();
      urlencoded.append("FollowedAppUserId",id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "CommonMethod/SetFollowVendor", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              this.isFollow = !this.isFollow
              this.$store.commit('addOrRemoveFollowingItemToList',id)
              this.getData()
            }
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true

          })
          .catch(error => console.log('error', error));
    },
    removeFollowedVendor(id){
      this.showLoaderDialog = true

      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);

      let urlencoded = new URLSearchParams();
      urlencoded.append("VendorID",id);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };
      let resStatus = null
      fetch(this.$baseUrl + "CommonMethod/SetFollowVendor", requestOptions)
          .then(response => {
            resStatus = response.status
            return response.text()
          })
          .then(result => {
            if (resStatus === 200) {
              this.isFollow = !this.isFollow
              this.$store.commit('addOrRemoveFollowingItemToList', id)
              this.getData()
            }
            this.showLoaderDialog = false
            this.resultText = result
            this.showResult = true

          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>
